let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dX6yW")).then(() => parcelRequire('9qxUw'));